import { render, staticRenderFns } from "./BetStatusIcon.vue?vue&type=template&id=2082fd30&scoped=true"
import script from "./BetStatusIcon.vue?vue&type=script&lang=js"
export * from "./BetStatusIcon.vue?vue&type=script&lang=js"
import style0 from "./BetStatusIcon.vue?vue&type=style&index=0&id=2082fd30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2082fd30",
  null
  
)

export default component.exports